import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card"
}
const _hoisted_2 = { class: "card-header border-0 pt-6" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "card-title" }
const _hoisted_5 = { class: "card-toolbar" }
const _hoisted_6 = {
  class: "d-flex justify-content-end",
  "data-kt-customer-table-toolbar": "base"
}
const _hoisted_7 = { class: "svg-icon svg-icon-2" }
const _hoisted_8 = { class: "card-body pt-0" }
const _hoisted_9 = ["href"]
const _hoisted_10 = {
  key: 0,
  class: "badge badge-light-success"
}
const _hoisted_11 = {
  key: 1,
  class: "badge badge-light-danger"
}
const _hoisted_12 = { class: "form-check form-switch form-check-custom form-check-solid" }
const _hoisted_13 = ["checked", "disabled", "onClick"]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "svg-icon svg-icon-2x" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UsersAdvancedSearch = _resolveComponent("UsersAdvancedSearch")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Datatable = _resolveComponent("Datatable")!

  return (_ctx.can('read', 'users'))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_UsersAdvancedSearch, {
                onTypeSelected: _ctx.onFilterChange,
                onReset: _ctx.onResetFilters
              }, null, 8, ["onTypeSelected", "onReset"])
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              (_ctx.can('create', 'users'))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "btn btn-primary d-none",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goTo('admins-creating')))
                  }, [
                    _createElementVNode("span", _hoisted_7, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotone/Navigation/Plus.svg" })
                    ]),
                    _createTextVNode(" " + _toDisplayString(_ctx.translate('addNewAdmin')), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_Datatable, {
            "table-data": _ctx.tableData,
            "table-header": _ctx.tableHeader,
            loading: _ctx.loading,
            "rows-per-page": 10,
            total: _ctx.totalItems,
            "enable-items-per-page-dropdown": false,
            onCurrentChange: _ctx.pageChanged
          }, {
            "cell-id": _withCtx(({ row: user }) => [
              _createTextVNode(_toDisplayString(user.id), 1)
            ]),
            "cell-name": _withCtx(({ row: user }) => [
              _createTextVNode(_toDisplayString(user.name == '' || user.name == null
              ? user.first_name + ' ' + user.last_name
              : ''), 1)
            ]),
            "cell-email": _withCtx(({ row: user }) => [
              _createElementVNode("a", {
                href: `mailto:${user.email}`,
                class: "text-gray-600 text-hover-primary mb-1"
              }, _toDisplayString(user.email), 9, _hoisted_9)
            ]),
            "cell-memberTypeTitle": _withCtx(({ row: user }) => [
              _createTextVNode(_toDisplayString(user.memberTypeLabel), 1)
            ]),
            "cell-createdAt": _withCtx(({ row: user }) => [
              _createTextVNode(_toDisplayString(user.createdAt), 1)
            ]),
            "cell-phone": _withCtx(({ row: user }) => [
              _createTextVNode(_toDisplayString(user.phone), 1)
            ]),
            "cell-is_active": _withCtx(({ row: user }) => [
              (user.is_active)
                ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.translate('active')), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.translate('inactive')), 1))
            ]),
            "cell-enable_mcp": _withCtx(({ row: user }) => [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("input", {
                  class: "form-check-input h-20px w-30px",
                  type: "checkbox",
                  checked: user.enable_mcp,
                  disabled: !_ctx.can('update', 'users'),
                  onClick: _withModifiers(($event: any) => (_ctx.toggleMcpUser(user)), ["prevent"])
                }, null, 8, _hoisted_13),
                _createElementVNode("span", {
                  class: _normalizeClass(["badge ms-2", 
                user.enable_mcp ? 'badge-light-success' : 'badge-light-danger'
              ])
                }, _toDisplayString(_ctx.translate(user.enable_mcp ? 'active' : 'inactive')), 3)
              ])
            ]),
            "cell-actions": _withCtx(({ row: user }) => [
              (_ctx.can('update', 'users'))
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: "#",
                    class: _normalizeClass(["btn btn-icon btn-bg-none btn-active-color-warning btn-sm", user.is_active ? '' : 'disabled']),
                    onClick: _withModifiers(($event: any) => (_ctx.toggleStatusUser(user)), ["prevent"])
                  }, [
                    _createElementVNode("span", _hoisted_15, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen034.svg" })
                    ])
                  ], 10, _hoisted_14))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["table-data", "table-header", "loading", "total", "onCurrentChange"])
        ])
      ]))
    : _createCommentVNode("", true)
}